import moment from "moment-timezone";
// ---------------------------------------
// to use only in GQL queries or upserts -
// ---------------------------------------

//
//  start month 2023-03-05T17:36:17 => 2023-03-05T00:00:00
//
export function getDBFormattedDate(date, format = undefined) {
    if (!date || !moment(date).isValid()) {
        return undefined;
    }
    return moment(date).startOf("day").utc(true).format(format);
}

//
//  start month 2023-03-05T17:36:17 => 2023-03-05T00:00:00
//

export function getDBFormattedStartDate(date) {
    return getDBFormattedDate(date);
}

//
//  start month 2023-03-05T17:36:17 => 2023-03-05T23:59:59
//

export function getDBFormattedEndDate(date) {
    if (!date || !moment(date).isValid()) {
        return undefined;
    }
    return moment(date).endOf("day").utc(true).format();
}

//
//  start month 2023-03-05T17:36:17 => 2023-03-01T00:00:00
//

export function getDBFormattedStartMonthDate(date) {
    if (!date || !moment(date).isValid()) {
        return undefined;
    }
    return moment(date).startOf("month").utc(true).format();
}

//
//  start month 2023-03-05T17:36:17 => 2023-03-31T00:00:00
//

export function getDBFormattedEndMonthDate(date) {
    if (!date || !moment(date).isValid()) {
        return undefined;
    }
    return moment(date).endOf("month").startOf("day").utc(true).format();
}
